import { TModel } from "Shared/models/t-model";
import { InquiryHistory } from "./inquiry-history";

export class Inquiry extends TModel {
  Id: number;
  RequestId: string;
  FirstName: string;
  LastName: string;
  IsCitizen: boolean;
  IsResident?: boolean;
  DateOfBirth: string;
  InquirySubjectId: string;
  InquiryDetails: string;
  AttachmentId?: string;
  IsCorrectInformation: boolean;
  ParentInquiryId?: number;
  EmployeeComment: string;
  SecuirtyCode: string;
  NumberOfReopen: number;
  InquiriesHistoryModel: InquiryHistory[];
  IsLastChild: boolean;
  IsParent: boolean;
  IsReachMaxNoReopen: boolean;
  HaveChildren: boolean;
  LastChildRequestId: string;
  ReCaptchaResopnse?: string;
  IsAnonymous: boolean;
  LastChildRequestStatus: boolean;
  ResendSecuirtyCode: string;
  IsReopen: boolean;
  PreferredCommunication: number;
}
